module.exports = "/img/city-kuching.b26bae94.jpg";